import type {
  CompositionV3Filters,
  PostingsV3Filters,
  SentimentV3Filters,
  TransitionsV3Filters,
} from '@revelio/data-access';

import { type Filter, FilterType } from '../types/filters';

type CompanyFilterResponse =
  | Pick<
      CompositionV3Filters,
      'rics_k10' | 'rics_k50' | 'rics_k400' | 'company'
    >
  | Pick<
      TransitionsV3Filters,
      'rics_k10' | 'rics_k50' | 'rics_k400' | 'company'
    >
  | Pick<PostingsV3Filters, 'rics_k10' | 'rics_k50' | 'rics_k400' | 'company'>
  | Pick<SentimentV3Filters, 'rics_k10' | 'rics_k50' | 'rics_k400' | 'company'>;

export const getV3CompanyFilters = (filter: Filter): CompanyFilterResponse => {
  if (filter.type !== FilterType.TREE) return {};

  return filter.selections.reduce<CompanyFilterResponse>((acc, selection) => {
    const lastSegment = selection.id.split('_').slice(-1)[0] ?? '';
    const numericStr = lastSegment.includes('.')
      ? (lastSegment.split('.').pop() ?? lastSegment)
      : lastSegment;
    const selectionId = parseInt(numericStr, 10);

    if (!Number.isFinite(selectionId)) {
      return acc;
    }

    if (selection.levelId === 'rics_k10') {
      return { ...acc, rics_k10: [...(acc.rics_k10 ?? []), selectionId] };
    }
    if (selection.levelId === 'rics_k50') {
      return { ...acc, rics_k50: [...(acc.rics_k50 ?? []), selectionId] };
    }
    if (selection.levelId === 'rics_k400') {
      return { ...acc, rics_k400: [...(acc.rics_k400 ?? []), selectionId] };
    }
    if (selection.levelId === 'company') {
      return { ...acc, company: [...(acc.company ?? []), selectionId] };
    }

    return acc;
  }, {});
};
